var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text",style:(_vm.customStyles)},[(_vm.htmlContent)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.htmlContent.replaceAll('\n', '<br>'))}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }